// extracted by mini-css-extract-plugin
export default {"ColSty":"CurrentThirtyDaysPV_ColSty__LodVz"};